'use client'

import { PageBuilder } from '@/app/components/PageBuilder'
import { PageHeading } from '@/app/components/PageHeading'
import { FaqQueryResult, GetPageQueryResult } from '@/sanity.types'

type ErrorPageContentProps = {
  page: GetPageQueryResult | null
  faqData?: FaqQueryResult | null
  fallbackTitle?: string
  fallbackMessage?: string
}

export function ErrorPageContent({
  page,
  faqData,
  fallbackTitle = 'Something went wrong!',
  fallbackMessage = 'An error occurred while loading this page.',
}: ErrorPageContentProps) {
  if (!page || !page._id) {
    return (
      <div className="content-container mt-5xl lg:mt-9xl">
        <div className="max-w-[1010px] mx-auto justify-center text-center">
          <h1>{fallbackTitle}</h1>
          <p className="mt-4xl">{fallbackMessage}</p>
        </div>
      </div>
    )
  }

  return (
    <>
      <PageHeading page={page} />
      <PageBuilder page={page} faqData={faqData || null} />
    </>
  )
}
